import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'
import { nextTick } from 'vue'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', '/callback', '/auth-redirect', '/bind'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/index'

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta &&
    typeof to.meta.title !== 'undefined' &&
    setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`)
  /* has token */
  if (storage.get(ACCESS_TOKEN)) {
    if (to.path === loginRoutePath || to.path === '/') {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      // check login user.roles is null
      if (store.getters.roles.length === 0) {
        // request login userInfo
        store
          .dispatch('GetInfo')
          .then((res) => {
            // const roles = res.result && res.result.role
            const roles = res.roles || store.getters.roles
            // generate dynamic router
            store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => {
              // Vue 3 使用 addRoute 而不是 addRoutes
              const routers = store.getters.routers
              console.log('准备添加动态路由，routers:', routers)
              // routers 是一个数组，包含 constantRouterMap 和新生成的路由（rootRouter 对象）
              // constantRouterMap 已经在 router 初始化时添加，只需要添加新生成的 rootRouter
              if (Array.isArray(routers)) {
                // 找到 rootRouter 对象（通常是数组的最后一个元素，有 children 且 path 为空）
                const rootRouter = routers.find(route => 
                  route && 
                  typeof route === 'object' &&
                  route.children && 
                  route.children.length > 0 && 
                  (!route.path || route.path === '')
                )
                if (rootRouter) {
                  // 检查并清理子路由中可能存在的重复 name
                  if (rootRouter.children && rootRouter.children.length > 0) {
                    rootRouter.children.forEach((child, index) => {
                      // 如果子路由的 name 与父路由相同，修改子路由的 name
                      if (child.name === rootRouter.name) {
                        // 使用更合理的名称生成策略
                        let newName = 'child'
                        if (child.path) {
                          // 使用路径生成名称，例如：/xiangmuguanli/projectUser -> xiangmuguanli_projectUser
                          newName = child.path
                            .replace(/^\//, '') // 移除开头的斜杠
                            .replace(/\//g, '_') // 将斜杠替换为下划线
                            .replace(/_+/g, '_') // 将多个下划线替换为单个
                            .replace(/^_|_$/g, '') // 移除开头和结尾的下划线
                          if (!newName) {
                            newName = 'child'
                          }
                        }
                        // 如果生成的名称仍然为空或与现有路由冲突，添加索引
                        if (!newName || rootRouter.children.some((c, i) => i !== index && c.name === newName)) {
                          newName = `child_${index}_${Date.now()}`
                        }
                        console.warn(`子路由名称冲突，将 ${child.name} 改为 ${newName}`, {
                          originalName: child.name,
                          newName: newName,
                          path: child.path
                        })
                        child.name = newName
                      }
                    })
                  }
                  
                  // 检查是否已经添加过这个路由（通过 name 判断）
                  const existingRoute = router.getRoutes().find(r => r.name === rootRouter.name)
                  if (!existingRoute) {
                    try {
                      // 添加 rootRouter，Vue 3 会自动处理其 children
                      // 注意：如果 path 为空字符串，Vue Router 会将其作为根路由
                      console.log('准备添加 rootRouter:', {
                        name: rootRouter.name,
                        path: rootRouter.path,
                        childrenCount: rootRouter.children?.length,
                        component: rootRouter.component,
                        componentType: typeof rootRouter.component
                      })
                      
                      // 检查 rootRouter.children 中的路由
                      if (rootRouter.children && rootRouter.children.length > 0) {
                        const projectUserInChildren = rootRouter.children.find(r => r.path && r.path.includes('projectUser'))
                        if (projectUserInChildren) {
                          console.log('rootRouter.children 中包含 projectUser 路由:', {
                            path: projectUserInChildren.path,
                            name: projectUserInChildren.name,
                            component: projectUserInChildren.component,
                            componentType: typeof projectUserInChildren.component
                          })
                        } else {
                          console.warn('rootRouter.children 中未找到 projectUser 路由')
                          console.log('rootRouter.children 中的所有路由:', rootRouter.children.map(r => ({
                            path: r.path,
                            name: r.name
                          })))
                        }
                      }
                      
                      router.addRoute(rootRouter)
                      console.log('动态路由已添加:', rootRouter.name, rootRouter.children?.length, '个子路由')
                      console.log('当前所有路由:', router.getRoutes().map(r => ({ 
                        name: r.name, 
                        path: r.path,
                        hasChildren: !!r.children,
                        childrenCount: r.children?.length || 0
                      })))
                      
                      // 验证路由是否真的被添加
                      const addedRoute = router.getRoutes().find(r => r.name === 'AppLayout' || (r.path === '' && r.children))
                      if (addedRoute) {
                        console.log('验证：AppLayout 路由已添加到 router:', {
                          name: addedRoute.name,
                          path: addedRoute.path,
                          childrenCount: addedRoute.children?.length,
                          hasComponent: !!(addedRoute.components || addedRoute.component),
                          componentType: typeof (addedRoute.components?.default || addedRoute.component),
                          redirect: addedRoute.redirect
                        })
                      } else {
                        console.error('验证失败：AppLayout 路由未找到！')
                      }
                      
                      // 检查 projectUser 路由是否正确注册
                      // 注意：Vue Router 在 addRoute 后，子路由可能不会立即出现在 getRoutes() 的顶层
                      // 需要检查父路由的 children
                      const appLayoutRoute = router.getRoutes().find(r => r.name === 'AppLayout' || (r.path === '' && r.children))
                      if (appLayoutRoute && appLayoutRoute.children) {
                        const projectUserRoute = appLayoutRoute.children.find(r => {
                          const path = r.path || ''
                          return path.includes('projectUser') || path === '/xiangmuguanli/projectUser'
                        })
                        if (projectUserRoute) {
                          console.log('找到 projectUser 路由（在 AppLayout 的 children 中）:', {
                            path: projectUserRoute.path,
                            name: projectUserRoute.name,
                            component: projectUserRoute.component,
                            componentType: typeof projectUserRoute.component,
                            isFunction: typeof projectUserRoute.component === 'function',
                            parent: appLayoutRoute.name
                          })
                          
                          // 测试路由解析
                          const testPath = '/xiangmuguanli/projectUser'
                          const testResolved = router.resolve(testPath)
                          console.log('测试路由解析 /xiangmuguanli/projectUser:', {
                            matched: testResolved?.matched?.length || 0,
                            matchedRoutes: testResolved?.matched?.map(m => ({
                              path: m.path,
                              name: m.name,
                              hasComponent: !!(m.components?.default || m.component)
                            })) || []
                          })
                        } else {
                          console.warn('在 AppLayout 的 children 中未找到 projectUser 路由')
                          console.log('AppLayout 的 children 路径列表:', appLayoutRoute.children.map(r => ({
                            path: r.path,
                            name: r.name
                          })))
                          console.log('查找包含 projectUser 的路由:', appLayoutRoute.children.filter(r => {
                            const path = r.path || ''
                            return path.includes('projectUser') || path.includes('xiangmuguanli')
                          }).map(r => ({ path: r.path, name: r.name })))
                        }
                      } else {
                        console.warn('未找到 AppLayout 路由或其 children')
                      }
                      
                      // 也检查顶层路由（可能在某些情况下会出现在顶层）
                      const topLevelProjectUserRoute = router.getRoutes().find(r => r.path && r.path.includes('projectUser'))
                      if (topLevelProjectUserRoute) {
                        console.log('找到 projectUser 路由（在顶层）:', {
                          path: topLevelProjectUserRoute.path,
                          name: topLevelProjectUserRoute.name,
                          component: topLevelProjectUserRoute.component,
                          componentType: typeof topLevelProjectUserRoute.component
                        })
                      }
                    } catch (error) {
                      console.error('添加路由失败:', error)
                      // 如果添加失败，尝试只添加子路由
                      if (rootRouter.children && rootRouter.children.length > 0) {
                        console.log('尝试单独添加子路由')
                        rootRouter.children.forEach(childRoute => {
                          try {
                            // 确保路径以 "/" 开头
                            if (childRoute.path && !childRoute.path.startsWith('/')) {
                              childRoute.path = '/' + childRoute.path
                            }
                            const existingChild = router.getRoutes().find(r => r.name === childRoute.name && r.path === childRoute.path)
                            if (!existingChild) {
                              router.addRoute(childRoute)
                              console.log('添加子路由:', childRoute.name, childRoute.path)
                            }
                          } catch (childError) {
                            console.error('添加子路由失败:', childRoute.name, childError)
                          }
                        })
                      }
                    }
                  } else {
                    console.log('路由已存在，跳过添加:', rootRouter.name)
                  }
                } else {
                  console.warn('未找到 rootRouter，尝试添加所有新路由')
                  // 如果没有找到 rootRouter，遍历添加所有新路由
                  // 跳过已经在 constantRouterMap 中的路由（/user, /404）
                  routers.forEach(route => {
                    if (route && route.path && route.path !== '/user' && route.path !== '/404') {
                      const existingRoute = router.getRoutes().find(r => r.path === route.path && r.name === route.name)
                      if (!existingRoute && route.component) {
                        router.addRoute(route)
                        console.log('添加路由:', route.path)
                      }
                    }
                  })
                }
              } else {
                console.error('routers 不是数组:', routers)
              }
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              // 确保路由已经添加完成后再跳转
              console.log('准备跳转到:', to.path, 'from:', from.path)
              console.log('当前所有路由:', router.getRoutes().map(r => ({ name: r.name, path: r.path })))
              
              // 路由添加完成后，使用 nextTick 确保路由已经注册
              // 然后使用 next() 重新触发路由匹配
              nextTick(() => {
                // 再次使用 nextTick 确保路由完全注册
                nextTick(() => {
                  // 检查路由是否真的存在
                  const finalResolved = router.resolve(to.path)
                  console.log('nextTick 后检查路由:', {
                    path: to.path,
                    matched: finalResolved?.matched?.length || 0,
                    matchedRoutes: finalResolved?.matched?.map(m => ({ 
                      path: m.path, 
                      name: m.name,
                      hasComponent: !!(m.components?.default || m.component),
                      componentType: typeof (m.components?.default || m.component),
                      redirect: m.redirect
                    })) || []
                  })
                  
                  // 如果路由匹配成功（matched 不为空且包含组件），使用 next({ path: to.path, replace: true }) 强制重新匹配
                  // 这样可以确保 Vue Router 使用新添加的路由进行匹配
                  if (finalResolved && finalResolved.matched && finalResolved.matched.length > 0) {
                    // 检查是否有组件（至少有一个匹配的路由有组件）
                    const hasComponent = finalResolved.matched.some(m => 
                      m.components?.default || m.component
                    )
                    if (hasComponent) {
                      console.log('路由匹配成功且有组件，执行跳转')
                      // 使用 next({ path: to.path, replace: true }) 强制重新匹配
                      // 这样可以确保 Vue Router 使用新添加的路由进行匹配
                      next({ path: to.path, replace: true })
                    } else {
                      console.warn('警告：匹配的路由没有组件！尝试重新匹配')
                      // 使用 next(to.path) 强制重新匹配
                      next({ path: to.path, replace: true })
                    }
                  } else {
                    console.warn('路由匹配失败，尝试重新匹配')
                    // 使用 next(to.path) 强制重新匹配
                    next({ path: to.path, replace: true })
                  }
                })
              })
            }).catch((error) => {
              console.error('生成路由失败:', error)
              notification.error({
                message: '错误',
                description: '生成路由失败，请重试',
              })
              next({ path: loginRoutePath })
            })
            /**
             * 提前获取省市区数据
             */
            // store.dispatch('getCity')
          })
          .catch((error) => {
            console.error('获取用户信息失败:', error)
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试',
            })
            // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
            store.dispatch('Logout').then(() => {
              router.push({ path: loginRoutePath })
            })
          })
      } else {
        // 路由已经添加，直接继续导航
        // 但是需要确保路由已经匹配
        console.log('检查路由匹配状态:', {
          path: to.path,
          allRoutes: router.getRoutes().length,
          routeNames: router.getRoutes().map(r => ({ name: r.name, path: r.path }))
        })
        
        // 检查路由是否存在
        const resolved = router.resolve(to.path)
        console.log('路由解析结果:', {
          path: to.path,
          matched: resolved?.matched?.length || 0,
          matchedRoutes: resolved?.matched?.map(m => ({ 
            path: m.path, 
            name: m.name,
            hasComponent: !!(m.components?.default || m.component)
          })) || []
        })
        
        if (resolved && resolved.matched && resolved.matched.length > 0) {
          const hasComponent = resolved.matched.some(m => m.components?.default || m.component)
          if (hasComponent) {
            console.log('路由已存在且有组件，直接导航')
            next()
          } else {
            console.warn('路由已存在但无组件，尝试重新匹配')
            next({ path: to.path, replace: true })
          }
        } else {
          console.warn('路由未匹配，尝试重新匹配:', to.path)
          // 如果路由未匹配，尝试重新匹配
          // 使用 nextTick 确保路由已经注册
          nextTick(() => {
            const retryResolved = router.resolve(to.path)
            if (retryResolved && retryResolved.matched && retryResolved.matched.length > 0) {
              console.log('重试后路由匹配成功')
              next({ path: to.path, replace: true })
            } else {
              console.error('重试后路由仍然未匹配，可能路由未正确添加')
              // 尝试查找所有包含该路径的路由
              const allRoutes = router.getRoutes()
              const matchingRoutes = allRoutes.filter(r => {
                if (r.path === to.path) return true
                if (r.children) {
                  return r.children.some(child => child.path === to.path)
                }
                return false
              })
              console.log('查找匹配的路由:', matchingRoutes.map(r => ({ name: r.name, path: r.path })))
              next({ path: to.path, replace: true })
            }
          })
        }
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach((to, from) => {
  NProgress.done() // finish progress bar
  
  // 记录所有访问过的路由，确保所有菜单点击都被记录
  // 通过事件通知 MultiTab 组件添加新页面
  console.log('[Permission] 路由导航完成:', {
    from: from?.path,
    to: to.path,
    title: to.meta?.title,
    name: to.name
  })
  
  // 触发全局事件，通知 MultiTab 组件添加新页面
  if (window.$vueApp && window.$vueApp.config && window.$vueApp.config.globalProperties) {
    // 使用事件总线通知 MultiTab
    const event = new CustomEvent('route-changed', {
      detail: {
        to: to,
        from: from
      }
    })
    window.dispatchEvent(event)
    
    // 也可以通过 $multiTab API 通知（如果存在）
    if (window.$vueApp.config.globalProperties.$multiTab) {
      console.log('[Permission] $multiTab API 存在')
    }
  }
})
